export enum AuthSignOutReason {
  SessionExpired = "session_expired",
  SignedOut = "signed_out",
}

export type AuthSession = {
  sessionId: string;
  dispatcherId: number | null;
  companyId: number | null;
  at: number;
};
